export default "__VITE_ASSET__0lQDqymA__"